import React, { useState } from "react"
import type { TraditionalRetail as TraditionalRetailType } from "types"
import * as styles from "./TraditionalRetail.css"
import { TraditionalRetailModal } from "./TraditionalRetailModal"
import { Typography } from "@shared/ui.primitives"
import { InfoIcon } from "@shared/ui.icons"
import { Price } from "./Price"
import { useTrackElementViewed } from "packages/membership/tracking"
import { dispatch } from "@shared/utils.events"
import { FindOutMoreAnchorContainer } from "@growth/page.products"

export type Props = { traditionalRetail: TraditionalRetailType }

const baseTrackingValues = {
  target: "Traditional Retail Price",
  location: "PDP",
}

export const TraditionalRetail: React.FC<Props> = ({ traditionalRetail }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { ref } = useTrackElementViewed(baseTrackingValues)

  const displayPopup = () => {
    dispatch("page element clicked", {
      target: "avg_typical_retail_price",
      details: "see_more_info",
      location: "avg_typical_retail_price",
    })
    setIsOpen(true)
  }

  return (
    <div className={styles.typicalPriceBannerWrapper}>
      <FindOutMoreAnchorContainer />
      <button
        data-testid="avg_retail_price_banner"
        onClick={displayPopup}
        ref={ref}
      >
        <div className={styles.spaceBetween}>
          <Typography as="h6" variant="subheader-7" colour={"primary-medium"}>
            Traditional Retail Price
          </Typography>
          <InfoIcon className={styles.infoIcon} />{" "}
        </div>
        <Typography variant="body-md" colour={"primary-medium"}>
          Other retailers might charge you{" "}
          <Price price={traditionalRetail.typicalPrice} /> for similar products
          like this one.
        </Typography>
      </button>

      <TraditionalRetailModal
        description={traditionalRetail.description}
        isOpen={isOpen}
        onDismiss={() => {
          setIsOpen(false)
        }}
      />
    </div>
  )
}
